import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './styles/index.css';
import 'services/i18next';

// Testet IndexedDB direkt, indem eine temporäre DB geöffnet wird
function checkIndexedDbAvailable(): Promise<boolean> {
  return new Promise(resolve => {
    try {
      const request = indexedDB.open('healthcheck_db');

      request.onsuccess = () => {
        const db = request.result;
        db.close();
        indexedDB.deleteDatabase('healthcheck_db'); // wieder löschen
        resolve(true);
      };

      request.onerror = () => resolve(false);
      request.onblocked = () => resolve(false);
    } catch (e) {
      resolve(false);
    }
  });
}

// Handler für Resume-Events
async function handleAppResume() {
  const ok = await checkIndexedDbAvailable();
  if (!ok) {
    console.warn('IndexedDB defekt – reloading…');
    window.location.reload();
  }
}

// Die Website-Buchung (iFrame auf fremden Seiten, Storno-Link aus der Mail) läuft ohne die App: Beide werden erst
// hier nachgeladen, damit das Widget weder die App noch Firebase mitlädt und schnell erscheint.
if (window.location.pathname.startsWith('/booking/')) {
  import('pages/BookingWidget').then(({ default: BookingWidget }) => {
    ReactDOM.render(
      <React.StrictMode>
        <BookingWidget />
      </React.StrictMode>,
      document.getElementById('root')
    );
  });
} else {
  // Check if no indexedDB errors occured
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      handleAppResume();
    }
  });

  import('./App').then(({ default: App }) => {
    ReactDOM.render(
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>,
      document.getElementById('root')
    );
  });
}
